export var BackgroundRepeatProps;
(function (BackgroundRepeatProps) {
    BackgroundRepeatProps["repeat"] = "repeat";
    BackgroundRepeatProps["noRepeat"] = "no-repeat";
    BackgroundRepeatProps["x"] = "repeatX";
    BackgroundRepeatProps["y"] = "repeatY";
    BackgroundRepeatProps["round"] = "round";
    BackgroundRepeatProps["space"] = "space";
})(BackgroundRepeatProps || (BackgroundRepeatProps = {}));
